var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "#073C50",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5477819,4.66666667 L11.0934262,4.66767347 C12.7307062,4.6732728 14.3704213,4.70645201 15.9937086,4.88519309 C16.831364,4.97774421 17.5275537,5.59671795 17.7232541,6.43598371 C18.0024724,7.63121528 18,8.93608433 18,10.1667091 L17.999334,10.6312302 C17.9951488,11.7215425 17.9637294,12.8510221 17.7199549,13.8970277 C17.523842,14.7362935 16.8278583,15.3552672 15.9908218,15.4478183 C14.0068037,15.666483 11.9990706,15.6679069 9.9991742,15.666483 L9.14188263,15.6662298 C7.42657806,15.6629171 5.70811358,15.6352452 4.00752661,15.4478183 C3.17007767,15.3554706 2.47409394,14.7362935 2.27839349,13.8970277 C2,12.7017961 2,11.3971305 2,10.1667091 L2.0006859,9.70211209 C2.00512638,8.61162464 2.03812422,7.4819893 2.28189917,6.43598371 C2.47759961,5.59671795 3.17275854,4.97774421 4.01061988,4.88519309 C5.81427259,4.68659189 7.63786511,4.6676967 9.45691827,4.66666667 L9.45691827,4.66666667 L10.5477819,4.66666667 Z M7.93534985,7.39668464 L7.93534985,12.6159575 L10.4781142,11.3154872 L10.4781142,11.3154872 L13.0221154,10.0145592 C12.453299,9.72178573 11.8869344,9.43030056 11.3217764,9.13944822 L7.93534985,7.39668464 Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.999e19cfc3d3d18b046bd3cc97f59b56.svg";
export { ForwardRef as ReactComponent };